import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { CheckPhoneNumberUpdateResponse, individualsService } from '@aslanpay/portal-common-lib';

const useCheckPhoneNumberUpdate = ({
  onSuccess,
  onError,
}: UseMutationOptions<CheckPhoneNumberUpdateResponse, Error, string>) => {
  return useMutation<CheckPhoneNumberUpdateResponse, Error, string>(
    (phoneNumber: string) => individualsService.checkPhoneNumberUpdate(phoneNumber),
    { onSuccess, onError }
  );
};

export default useCheckPhoneNumberUpdate;
